import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItemWithEntityName } from '~/types/models'

export enum SupplierTypeIds {
  SUPPLIER_PLUS_TSD = 1,
  SUPPLIER = 2,
}

export function getSupplierTypes(): ISelectItemWithEntityName[] {
  return [
    {
      id: SupplierTypeIds.SUPPLIER_PLUS_TSD,
      label: 'Supplier + TSD',
      entityName: 'tsdSupplier',
    },
    {
      id: SupplierTypeIds.SUPPLIER,
      label: 'Supplier',
      entityName: 'supplier',
    },
  ]
}

export const getSupplierTypeByLabel = getItemByLabelFactory(getSupplierTypes)
export const getSupplierTypeById = getItemByIdFactory(getSupplierTypes)
